import React, { useEffect, useState } from "react";

import { Button } from "../../Button/index";
import { Icon } from "../../../components/Layout/icons/index";
import ModuleActions from "@/modules/entity/actions";

import { storage } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { useHistory } from "react-router";
import Actions from "../../../store/actions";
import Avatar from "@/assets/images/svg/avatar6.svg";
import { Link } from "react-router-dom";
import DownArrow from "@/assets/images/icons/arrow-down.svg";
import Message from "./message-icon.png";
import "./style.scss";
import UserDropdown from "./UserDrompdown";
import NotificationIconIcon from "@/assets/images/svg/notification-icon.svg";

export const Header = () => {
  const profile = useSelector((state) => state.auth.user);
  const activeOrganization = get(profile, "organization");

  const toolbarTitle = useSelector((state) => state.system.toolbarTitle);
  const history = useHistory();
  const dispatch = useDispatch();
  const storageToken = storage.get("token");
  const [unredMessage, setUnreadMessage] = useState();
  const [branches, setBranches] = useState();
  const logoutHandler = () => {
    storage.remove("token");
    window.location.reload();
  };
  const lockHandler = () => {
    storage.set("lock_phone", get(profile, "phone"));
    storage.remove("token");
    history.push("/unlock");
    dispatch(Actions.auth.SetToken.request(null));
  };

  const getMessages = async () => {
    try {
      const response = await fetch(
        `https://api-kafe.zim-zim.uz/api/v1/app/employee/chat/unread/count`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storageToken}`,
          },
        }
      );
      const data = await response.json();
      setUnreadMessage(data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
    }
  };

  const loadItems = () => {
    dispatch(
      ModuleActions.LoadDefault.request({
        url: "/branches",
        cb: {
          success: ({ data }) => {
            setBranches(data);
            dispatch(Actions.system.GetOrganizations.trigger(data));
          },
          error: () => {},
        },
      })
    );
  };

  useEffect(() => {
    getMessages();
    loadItems();
  }, []);
  return (
    <header className={"header"}>
      <span className="header-corner" />
      <div className="header-wrapper">
        <div className="!flex !items-center">
          <Button
            size="md"
            variant="filled"
            className="header-back"
            onClick={() => history.goBack()}
          >
            <Icon icon="arrow-right" className="h-4 w-4" />
          </Button>
          <h1 className="header-title">{toolbarTitle ? toolbarTitle : ""}</h1>
        </div>
        <div className="header-right">
          {branches && branches.length > 1 && (
            <div
              className={`company-name !flex !items-center cursor-pointer`}
              onClick={() => {
                if (branches.length > 1) {
                  dispatch(Actions.system.ToggleOrganizationModal(true));
                }
                dispatch(Actions.system.ToggleOrganizationModal(true));
              }}
            >
              <div className="!flex !items-center">
                {activeOrganization
                  ? get(activeOrganization, "name")
                  : " Выберите точку"}
                {activeOrganization && (
                  <img src={DownArrow} alt="" className="ml-15" />
                )}
              </div>
            </div>
          )}
          <div className="header-icons">
            {unredMessage && unredMessage > 0 && (
              <div
                className="chat-icon"
                onClick={() =>
                  history.push(`/organizations?unread_message=${1}`)
                }
              >
                <img src={Message} alt="" />
                <span className="badge">{unredMessage} </span>
              </div>
            )}
            <Button
              size="lg"
              variant="filled"
              roundness="half"
              onClick={() => history.push("/notification")}
              className="header-btn"
            >
              <img
                width={24}
                height={24}
                src={NotificationIconIcon}
                alt=""
              />
            </Button>
            <Button
              size="lg"
              variant="filled"
              roundness="half"
              onClick={lockHandler}
              className="header-btn"
            >
              <Icon icon="lock-icon" className="icon" width={24} height={24} />
            </Button>
            <Button
              size="lg"
              variant="filled"
              roundness="half"
              onClick={logoutHandler}
              className="header-btn"
            >
              <Icon icon="logout-outlined" className="icon" />
            </Button>
          </div>

          <div className="header-user">
            <div className="header-user">
              <UserDropdown profile={profile} lockHandler={lockHandler} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
